import React from 'react';
import { motion } from 'framer-motion';

const Card = ({ children, className = '', hoverEffect = false, onClick }) => {
    return (
        <motion.div
            whileHover={hoverEffect ? { y: -5 } : {}}
            className={`
        bg-white/80 backdrop-blur-md 
        border border-white/20 
        rounded-2xl shadow-xl shadow-slate-200/50 
        p-6 
        ${className}
      `}
            onClick={onClick}
        >
            {children}
        </motion.div>
    );
};

export default Card;
